import { useMutation, useQueryClient } from "@tanstack/react-query";
import { solicitudes as solicitudesAPI } from "api/solicitudes";
import { ModificarPrimerVencimientoRequest } from "api/types/originacion/services/analisisSolicitudTypes";
import { sendToast } from "libs/sendMessage";
import useToken from "./useToken";

const modificarPrimerVencimiento = async (
  token: string,
  props: ModificarPrimerVencimientoRequest
): Promise<void> => {
  return solicitudesAPI(token).postModificarPrimerVencimiento(props);
};

export const useModificarPrimerVencimiento = (solicitudId: number) => {
  const queryClient = useQueryClient();
  const token = useToken();

  return useMutation(
    (props: ModificarPrimerVencimientoRequest) =>
      modificarPrimerVencimiento(token, props),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          "detalleSolicitudConsumo",
          { id: solicitudId },
        ]);
      },
      onError: () => {
        sendToast({
          message: "Error al modificar el primer vencimiento",
          type: "error",
        });
      },
    }
  );
};
